import { DEFAULT_DELIVERY_SETTINGS, DEFAULT_CAMPAIGN, DEFAULT_HOME_LAYOUT } from '../data/mockData';

export const LS_KEY = 'kelate_app_v4';
export const SOUND_KEY = 'kelate_sound';

const DEFAULT_MERCHANT_NOTIF = {
  sound: true, newOrder: true, payment: true, pickup: true, payout: true,
  reviews: true, marketing: false, system: true, volume: 'medium', desktop: false,
};
const DEFAULT_ADMIN_NOTIF = { critical: true, high: true, volume: 'high', desktop: false };

export function loadState() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) { /* reseed */ }
  return null;
}

export function initialState() {
  const saved = loadState();
  if (saved) return { partners: [], campaign: DEFAULT_CAMPAIGN, merchantProfiles: {}, customMerchants: [], adminMerchants: [], planRequests: [], customProducts: [], supportTickets: [], riderAvailability: {}, homeLayout: DEFAULT_HOME_LAYOUT, madeInKelantan: null, homeHero: null, referralProgram: { enabled: true, discountType: 'FIXED', discountValue: 5, minSpend: 0 }, referralUses: [], referralOwners: {}, wallets: {}, topUpRequests: [], walletTransactions: [], vouchers: [], ...saved };
  return {
    cart: [],
    orders: [],
    deliveries: [],
    cashEntries: [],
    digitalCollections: [],
    payouts: [],
    notifications: [],
    auditLog: [],
    applications: [],
    deliverySettings: DEFAULT_DELIVERY_SETTINGS,
    partners: [],
    campaign: DEFAULT_CAMPAIGN,
    merchantProfiles: {},
    customMerchants: [],
    adminMerchants: [],
    planRequests: [],
    customProducts: [],
    supportTickets: [],
    riderAvailability: {},
    homeLayout: DEFAULT_HOME_LAYOUT,
    madeInKelantan: null,
    homeHero: null,
    referralProgram: { enabled: true, discountType: 'FIXED', discountValue: 5, minSpend: 0 },
    referralUses: [],
    referralOwners: {},
    wallets: {},
    topUpRequests: [],
    walletTransactions: [],
    vouchers: [],
    favourites: [],
    follows: [],
    recentlyViewed: [],
    merchantNotif: DEFAULT_MERCHANT_NOTIF,
    adminNotif: DEFAULT_ADMIN_NOTIF,
    counters: { order: 10884, delivery: 5004, payout: 2001 },
  };
}

export function soundEnabled() {
  return localStorage.getItem(SOUND_KEY) === 'on';
}
export function setSoundEnabled(on) {
  localStorage.setItem(SOUND_KEY, on ? 'on' : 'off');
}
export function soundPreferenceKnown() {
  return localStorage.getItem(SOUND_KEY) !== null;
}

export function findMerchantIn(s, id) {
  return s.customMerchants.find((m) => m.id === id) || null;
}

export function referralCodeFor(email) {
  if (!email) return '';
  let h = 0;
  for (let i = 0; i < email.length; i++) h = (h * 31 + email.charCodeAt(i)) >>> 0;
  return `KEL-${h.toString(36).toUpperCase().padStart(6, '0').slice(-6)}`;
}
